
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/salesforce",
      function () {
        return require("private-next-pages/destinations/salesforce.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/salesforce"])
      });
    }
  